var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckboxCheckedico = function SvgCheckboxCheckedico(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.231,
    width: 24,
    height: 24,
    rx: 2,
    fill: "#fff",
    stroke: "#004AAD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.364 13.46c.094-.283.376-.552.659-.74.47-.379 1.035-.379 1.506-.095.847.472 1.6 1.133 2.259 1.795.847.85 1.506 1.795 2.165 2.74 0 .094.094.094.094.094l.847-1.7c1.788-3.213 4.142-5.952 7.154-8.03 1.412-1.04 3.012-1.795 4.706-2.456.941-.378 1.883.283 1.883 1.133v.095c0 .094-.095.567-.095.567-.094.472-.376.566-.847.66-1.506.568-2.918 1.229-4.236 2.174-2.164 1.605-3.953 3.59-5.459 5.856a25.781 25.781 0 0 0-2.541 5.101c-.189.473-.47.756-1.036.85h-.376c-.47-.094-.847-.377-1.036-.755-.753-1.417-1.506-2.74-2.541-3.873-.659-.756-1.318-1.512-2.165-1.984-.47-.283-.753-.567-.941-1.04v-.391Z",
    fill: "#004AAD"
  })));
};
export default SvgCheckboxCheckedico;